import { render, staticRenderFns } from "./MealBreak.vue?vue&type=template&id=344986a1&"
import script from "./MealBreak.vue?vue&type=script&lang=js&"
export * from "./MealBreak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports